import { Component, OnInit } from '@angular/core';
import {NgbDate, NgbCalendar, NgbDateParserFormatter, NgbRadio} from '@ng-bootstrap/ng-bootstrap';
import { PortfolioService } from 'src/app/shared/services/portfolio.service';
import { KycService } from 'src/app/shared/services/kyc.service';
import { FundingService } from 'src/app/shared/services/funding.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { from } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.scss']
})
export class ActivitiesComponent implements OnInit {

  hoveredDate: NgbDate | null = null;

  fromDate: NgbDate | null;
  toDate: NgbDate | null;

  collectionSize = 1;   
  transaction: any[];
  exchangeRate: number;
  deposits: boolean = false
  usExchangeRate: number;
  searchText: string;
  withdrawals: {};
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  credited: any;
  userProfile: {};
  userID: string;
  switch_expression:number;
  holdings: [];
  investmentType:any =[];
  error: boolean = false;
  errMsg: string;

  constructor(private calendar: NgbCalendar,
              public formatter: NgbDateParserFormatter,
              private api:PortfolioService,
              private kyc:KycService,
              private SpinnerService: NgxSpinnerService,
              private fund: FundingService) { 

              this.fromDate = calendar.getToday();
              this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
  }

 onchange(num:number){
  this.switch_expression = num;
 }

  public onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage*(pageNum - 1);
  }
  
  public changePagesize(num: number): void {
  this.itemsPerPage = this.pageSize + num;
}

  ngOnInit() {
    this.api.getProfile().subscribe((res:any) => {
      this.userProfile = res.data;
      this.userID = res.data.id;
      this.getPortfolio(this.userID);
    });
    this.getTransactions();
    
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  //getStatement
  getUserStatement(){
    this.api.getStatement('STATEMENT')
      .subscribe((res:any)=>{
        console.log(res)
      })
  }

  getTransactions(){
    this.SpinnerService.show();
    this.kyc.getUserWalletTransaction()
      .subscribe((res:any)=>{
        if(res){
          this.transaction = res.data;
          this.credited = this.transaction.filter(withdraw =>withdraw.action == 'CREDIT');
   
          let type = this.transaction.filter(withdraw =>withdraw.action == 'WITHDRAW');
          this.withdrawals = type;
        }
       this.SpinnerService.hide();
      },err=>{
        this.SpinnerService.hide();
        this.error = true;
            this.errMsg = err.error.message;
      })
  }



getPortfolio(userID){
  this.api.portfolio(userID)
  .subscribe((data:any)=>{
    this.holdings = data.data.holdings;
    if(this.holdings){
      let investment = this.holdings.filter((types:any)  => 
                  types.type == 'FUND'
                          
      );
      investment.forEach((element:any) => {
        element.holdings.forEach(elements => {
          this.investmentType.push(elements);

        });
      });
     
    }
    else{
      this.investmentType  = null;
    }
  
  },err =>{
    this.investmentType  = null
  })
}
}
